<template>
    <div>
        <div class="text-center">
            <h2 class="pt-12 px-5" v-text="$t('FAQ_OTHER_CATEGORIES_NOT_FOUND')"></h2>
            <p class="pb-3" v-text="$t('FAQ_OTHER_CATEGORIES_TRY')"></p>
        </div>

        <div v-if="!isUserLoggedIn" class="flex flex-wrap">
            <div
                v-if="showEmptyBox(notLoggedInCategories)"
                class="faq__empty faq__image background--paper divider--container h-full">
                <div class="divider-white--top"></div>
                <div class="divider-white--bottom"></div>
            </div>

            <faq-category-box
                v-for="(category, index) in notLoggedInCategories"
                :category="category"
                :key="index">
            </faq-category-box>

            <div
                v-if="showEmptyBox(notLoggedInCategories)"
                class="faq__empty faq__image background--paper divider--container h-full">
                <div class="divider-white--top"></div>
                <div class="divider-white--bottom"></div>
            </div>
        </div>

        <div v-if="isUserLoggedIn" class="flex flex-wrap">
            <faq-category-box
                v-for="(category, index) in categories"
                :category="category"
                :key="index">
            </faq-category-box>
        </div>
    </div>
</template>

<script>
import FaqCategoryBox from '@/components/partials/faq/FaqCategoryBox';

export default {
    name: 'FaqOtherCategories',
    methods: {
        /**
         * Reduce method to check if the current route exists in the array.
         *
         * @param {Boolean} isCurrentRoute
         * @param {Object} current
         *
         * @return {Boolean}
         */
        isCurrentRoute(isCurrentRoute, current) {
            if (this.$router.currentRoute.path.includes(current.path)) {
                isCurrentRoute = true;
            }

            return isCurrentRoute;
        },

        /**
         * Check if empty box should be shown for the given array of categories.
         *
         * @param {Array} categories
         *
         * @return {Boolean}
         */
        showEmptyBox(categories) {
            return categories.reduce(this.isCurrentRoute.bind(this), false);
        },
    },
    computed: {
        isUserLoggedIn() {
            return this.$store.getters['auth/isUserLoggedIn'];
        },
        categories() {
            return this.$store.getters['faq/getCategories'];
        },
        loggedInCategories() {
            return this.$store.getters['faq/getLoggedInCategories'];
        },
        notLoggedInCategories() {
            return this.$store.getters['faq/getNotLoggedInCategories'];
        },
    },
    components: {
        FaqCategoryBox,
    },
};
</script>
